import React from "react";
import Grid from "@mui/material/GridLegacy";

export default function ChangeCourses({ onSwitch, arrangeSquare }: { onSwitch: () => void; arrangeSquare: string }) {
    return (
        <Grid item xs={12} md={1} textAlign="center" onClick={onSwitch}>
            <img
                src={arrangeSquare}
                width={32}
                alt="Change Courses"
                style={{
                    marginTop: "6px",
                    transform: "rotate(90deg)"
                }}
            />
        </Grid>
    );
}
